module.exports = __webpack_public_path__ + "img/icon_Pet-Friendly.ae1cccb4.svg";